import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

class CheckListBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    options: pt.array.isRequired,
    textProp: pt.string.isRequired,
    valueProp: pt.string.isRequired,
    queryFieldSetup: pt.shape({
      Name: pt.string,
      Operator: pt.string,
      Group: pt.string
    }),
    inline: pt.bool.isRequired
  })

  static defaultProps = {
    options: [],
    textProp: 'Text',
    valueProp: 'Value',
    inline: false
  }

  onCheckChanged (checkName, event) {
    const { input: { value, onChange, name } } = this.props

    const newValues = value ? _.clone(value) : []

    if (_.isArray(newValues) === false) {
      throw new Error(`Something went wrong!  Values for field '${name}' should be an array!`)
    }
    const isChecked = event.target.checked

    const checkIndex = _.indexOf(newValues, checkName)
    if (isChecked) {
      if (checkIndex === -1) {
        newValues.push(checkName)
      }
    } else {
      if (checkIndex > -1) {
        _.pullAt(newValues, [checkIndex])
      }
    }
    onChange(newValues)
  }

  renderOptions (inline, options = [], textProp, valueProp, fieldProps) {
    const { 'data-tid': testId = '', value, name, readonly } = fieldProps

    return (
      <div className={clsx(!inline && 'grid-x grid-padding-x small-up-1 medium-up-1 large-up-1')}>
        {_.map(options, (o, i) => {
          const valuePropValue = o[valueProp || 'Value']
          const textPropValue = o[textProp || 'Text']

          return <>
            {
              readonly
                ? inline
                  ? <React.Fragment><input disabled data-tid={`${testId}_${i}`} key={valuePropValue} type='checkbox' checked={_.indexOf(value, valuePropValue) > -1} id={`${name}_${i}`}
                    value={valuePropValue} /><label>{textPropValue || valuePropValue}</label></React.Fragment>
                  : <div className="cell"><input disabled data-tid={`${testId}_${i}`} key={valuePropValue} type='checkbox' checked={_.indexOf(value, valuePropValue) > -1} id={`${name}_${i}`}
                    value={valuePropValue} /><label>{textPropValue || valuePropValue}</label></div>
                : inline
                  ? <React.Fragment><input data-tid={`${testId}_${i}`} key={valuePropValue} type='checkbox' checked={_.indexOf(value, valuePropValue) > -1} id={`${name}_${i}`} onChange={this.onCheckChanged.bind(this, valuePropValue)}
                    value={valuePropValue} /><label htmlFor={`${name}_${i}`}>{textPropValue || valuePropValue}</label></React.Fragment>
                  : <div className="cell"><input data-tid={`${testId}_${i}`} key={valuePropValue} type='checkbox' checked={_.indexOf(value, valuePropValue) > -1} id={`${name}_${i}`} onChange={this.onCheckChanged.bind(this, valuePropValue)}
                    value={valuePropValue} /><label htmlFor={`${name}_${i}`}>{textPropValue || valuePropValue}</label></div>
            }
          </>
        })}
      </div>
    )
  }

  render () {
    const { inline, options, textProp, valueProp, ...rest } = this.props

    return (
      <FieldLayoutBox {...rest}>
        {(fieldProps) => this.renderOptions(inline, options, textProp, valueProp, fieldProps)}
      </FieldLayoutBox>
    )
  }
};

export const CheckListBox = ({ name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} {...rest} component={CheckListBoxClass} /> } // eslint-disable-line
export default CheckListBox
